import { atom } from 'jotai';

/**
 * Power data shape returned by FPM's /api/power-graph endpoint and the FPM
 * `power` WebSocket channel. Distinct from GolfTrack's legacy Power shape
 * (PhA/PhB/PhC fields); FPM uses per-phase active power + line voltages.
 */
export interface Power {
  BuildingID: string;
  Timestamp: string;
  TimestampMs?: number;
  PwrA: number;
  PwrB: number;
  PwrC: number;
  VA: number;
  VB: number;
  VC: number;
  Grid: number;
  Load: number;
  Solar: number;
  Demand: number;
  DayPeak: number;
  PeakTime: number;
  DaykWhNet: number;
  DaykWhImport: number;
  DaykWhExport: number;
  NCharging: number;
  NWaiting: number;
}

export const powerAtom = atom<{ [BuildingID: string]: Power[] }>({});
